export default {
    state: {
    },
    mutations: {
    },
    actions: {
        async getCashReportInfo({dispatch}, obj) {
            return await dispatch('apiQuery', {
                method:`/reports/balance?date_begin=${obj.date_begin}&date_end=${obj.date_end}`
            })
        }
    },
    getters: {
    }
}